import React from "react";
import { func, shape, string } from "prop-types";

import * as S from "./styled";

const DateTimeRemoveButton = ({ datetime, onRemoveDatetime }) => (
  <S.RemoveButtonContainer>
    <S.RemoveButton>
      <S.RemoveTrashSign
        onClick={() => {
          onRemoveDatetime(datetime);
        }}
      />
    </S.RemoveButton>
  </S.RemoveButtonContainer>
);

DateTimeRemoveButton.propTypes = {
  onRemoveDatetime: func.isRequired,
  datetime: shape({ key: string, date: string, time: string }).isRequired
};

export default DateTimeRemoveButton;
